import { useEffect, useState, type ImgHTMLAttributes } from 'react';
import { GENERIC_PROFILE_AVATAR_SRC } from '../constants/homePageContent';

type ProfileAvatarImageProps = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'referrerPolicy' | 'onError'
> & {
  /** Shown when the primary `src` fails to load (broken URL / CORS). */
  fallbackSrc?: string;
};

/** Google profile photo URLs require no-referrer or the browser blocks the image. */
export function ProfileAvatarImage({
  alt = '',
  src,
  fallbackSrc = GENERIC_PROFILE_AVATAR_SRC,
  ...props
}: ProfileAvatarImageProps) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  return (
    <img
      {...props}
      alt={alt}
      src={failed || !src ? fallbackSrc : src}
      referrerPolicy="no-referrer"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
